// Bounded, non-identifying browser evidence. Never an authoritative revenue record.
export const DELIVERY_MESSAGES = Object.freeze({
  IDLE: "Waiting for this placement to approach the screen.",
  CONSENT_REQUIRED: "Advertising consent is missing or no longer valid.",
  CONSENT_UNAVAILABLE: "Advertising consent is missing or no longer valid.",
  CONSENT_WITHDRAWN: "Consent was withdrawn; subsequent advertising work was stopped.",
  REQUESTING: "Requesting a decision from SURGEDOME, not from Google.",
  SELECTED: "SURGEDOME selected an advertisement; rendering is not yet confirmed.",
  INTERNAL_SELECTED: "An eligible House or Direct campaign won under the existing priorities.",
  GAM_ELIGIBLE: "The server selected GAM. No Google request or paid impression is proven.",
  GPT_LOADING: "Loading Google's advertising library.",
  GPT_READY: "Google's advertising library is ready.",
  GPT_SLOT_DEFINED: "The Google slot was registered.",
  GPT_REQUEST_INVOKED: "The browser invoked Google's request API; network completion is not proven.",
  GPT_REQUEST_EVENT: "GPT reported a slot request. Paid demand and revenue are not verified.",
  GAM_RENDERED: "GPT reported a non-empty, size-compatible creative. Paid status is not verified.",
  GAM_EMPTY: "Google returned no advertisement for this request.",
  GAM_TIMEOUT: "Google did not finish this attempt in time; the attempt was stopped.",
  GAM_LOADER_FAILED: "Google's library could not load. Check blocking software or connectivity.",
  GAM_SLOT_FAILED: "The Google slot could not be initialized.",
  GAM_RENDER_ERROR: "The Google advertisement could not be rendered.",
  GAM_SIZE_UNAVAILABLE: "No configured Google size fits this placement's measured width.",
  GAM_SIZE_MISMATCH: "The returned creative did not match the permitted size.",
  GAM_VIEWPORT_SHRINK: "The advertisement was removed after the screen became too narrow. It was not refreshed.",
  FILLED: "The creative rendered. This does not establish a paid impression.",
  NO_FILL: "No advertisement rendered. Consult the server check for configuration reasons.",
  NO_ELIGIBLE_DEMAND: "No eligible advertisement was selected.",
  INTERNAL_FALLBACK: "Trying the one permitted House/Direct fallback.",
  DECISION_UNAVAILABLE: "The SURGEDOME decision request failed.",
  CHECK_UNAVAILABLE: "The server check could not complete. Reload and retry.",
  EXPIRED: "The selected advertisement expired.",
  PLACEMENT_UNAVAILABLE: "The placement is missing or disabled.",
  ENVIRONMENT_GATE_OFF: "The platform's external/GAM delivery switches are off.",
  PLATFORM_GATE_OFF: "Platform GAM delivery has not been activated.",
  PUBLICATION_GAM_DISABLED: "GAM is disabled for this publication.",
  PUBLICATION_ALLOCATION_OFF: "This placement needs an enabled, activated GAM allocation.",
  PREFLIGHT_NOT_APPROVED: "A platform administrator must approve this configuration.",
  PREFLIGHT_STALE: "The configuration changed after approval. A fresh review is required."
});

export function emitBrowserAdDiagnostic(placement, code) {
  if (typeof window !== "undefined" && DELIVERY_MESSAGES[code]) {
    window.dispatchEvent(new CustomEvent("surgedome:ad-diagnostic", { detail: { placement, code } }));
  }
}

export function parseBrowserAdReport(text, publicationId) {
  if (typeof text !== "string" || text.length > 65536) throw new Error("Report is too large.");
  const report = JSON.parse(text);
  if (report.version !== 1 || report.publicationId !== publicationId || !Array.isArray(report.events) || report.events.length > 100) throw new Error("Choose a report for this publication.");
  const events = report.events.map(row => {
    if (!row || typeof row.placement !== "string" || !/^[a-zA-Z0-9_-]{1,100}$/.test(row.placement) || !Object.hasOwn(DELIVERY_MESSAGES, row.code) || !Number.isFinite(Date.parse(row.at))) throw new Error("Invalid diagnostic report.");
    return { placement: row.placement, code: row.code, at: row.at };
  });
  return { events };
}
